import React, { useEffect, useRef } from 'react';
import './Features.css';

function Features() {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    cardsRef.current.forEach(card => {
      if (card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'all 0.6s ease-out';
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: '🎙️',
      title: 'Voice-First Interface',
      description: 'Simply speak your transactions. Our AI understands natural language and converts your voice into accurate financial records instantly.'
    },
    {
      icon: '🌐',
      title: '12+ Indian Languages',
      description: 'Work in your comfort language. We support Hindi, English, Odia, Bengali, Telugu, Tamil, Marathi, Gujarati, Kannada, Malayalam, Punjabi, and more.'
    },
    {
      icon: '🤖',
      title: 'AI-Powered Accuracy',
      description: 'Advanced AI ensures precision in every entry. Smart categorization, automatic calculations, and intelligent insights for your business.'
    },
    {
      icon: '📊',
      title: 'Real-Time Reports',
      description: 'Get instant financial insights and reports. Track your business health with beautiful dashboards and actionable analytics.'
    },
    {
      icon: '🔒',
      title: 'Bank-Grade Security',
      description: 'Your data is encrypted and secure. We follow industry-best practices to keep your financial information safe and private.'
    },
    {
      icon: '⚡',
      title: 'Lightning Fast',
      description: 'Save hours every week. What used to take hours now takes minutes. Focus on growing your business, not managing books.'
    }
  ];

  return (
    <section className="features" id="features">
      <h2 className="section-title">Why Talkbooks?</h2>
      <p className="section-subtitle">Intelligent bookkeeping designed for the modern Indian business</p>

      <div className="features-grid">
        {features.map((feature, index) => (
          <div
            key={index}
            className="feature-card"
            ref={el => cardsRef.current[index] = el}
          >
            <span className="feature-icon">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;

